/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { MenuLanguageAudio, CircProgressBar } from '../../'
import { Container, ContainerProgressBar, BtnPlayPauseContainer, MenuLanguageContainer, ContainerHover, DescriptionContainer, TextDescription } from './index.styled'
import { ImPause2, ImPlay3, ImRadioChecked2 as BgHover } from 'react-icons/all'
import { ASSETS_FOLDER } from '../../../assets';

function LearnMoreComponent({pct = 1, audio, locale }) {
  const [src, setSrc] = useState("")
  const intl = useIntl()
  const voiceOffRef = React.useRef()
  const [ isPlaying, setIsPlaying] = useState(false);
  const [ isHover, setIsOver ] = useState(false);
  const [ duration, setDuration ] = useState(0);
  const [ language, setLanguage ] = useState("en");
  const [ currentTime, setCurrentTime ] = useState(0);
  const [ percentage, setPercentage ] = useState(0);

  useEffect(() => {
    let lg = "en"
    if(locale === "pt"){
      lg = "pt"
    }
    setLanguage(lg)
  }, [locale])

  const changeLanguage = (lang) => {
    setLanguage(lang);
  }

  const setAudio = () => {
    const src = `${ASSETS_FOLDER}/voice-off/${language}/${audio}`
    setSrc(src)
    if (!voiceOffRef.current) return;
    if (!window.voiceOffRef) window.voiceOffRef = voiceOffRef.current
    voiceOffRef.current.src = src;
    voiceOffRef.current.volume = 1;
  }

  const setProgress = () => {
    let currentTime = voiceOffRef?.current?.currentTime
    let perc = (currentTime / duration * 100).toFixed(2);
    setPercentage(perc)
  }

  React.useEffect(() => {
    setAudio()
  }, [])
  
  React.useEffect(() => {
    setAudio()
  }, [language])

  React.useEffect(() => {
    setProgress()
  }, [currentTime])


  const renderIcon = () => isPlaying ? <ImPause2 size={24} className="btn-pause" /> : <ImPlay3 className="btn-play" size={28} />;
  const stopText = intl.formatMessage({ id: "stop" })
  const voiceOverText = intl.formatMessage({ id: "voice-over" })
  return (
    <Container>
      <BtnPlayPauseContainer className={!isPlaying ? 'bordered': ''}
                        onMouseOver={() => setIsOver(true)}
                        onMouseOut={() => setIsOver(false)}
                        >
        {renderIcon()}
        <MenuLanguageContainer className={isHover ? 'hover': ''}>
          <MenuLanguageAudio handlerChangeLanguage={changeLanguage} currentLanguage={language}/>
        </MenuLanguageContainer>
        <ContainerHover onClick={() => {
          if(!isPlaying){ voiceOffRef?.current?.play() }else{ voiceOffRef?.current?.pause() }
          setIsPlaying(() => !isPlaying)
        }}>
          <BgHover className="act-hover" />
        </ContainerHover>
        {isPlaying &&
          <ContainerProgressBar>
            <CircProgressBar width={'100%'} value={percentage} />
          </ContainerProgressBar>
         }
      </BtnPlayPauseContainer>
      <DescriptionContainer>
          <TextDescription className={isHover ? 'hover': ''}>{isPlaying ? stopText : voiceOverText}</TextDescription>
      </DescriptionContainer>
      <audio 
        ref={voiceOffRef} 
        src={src} 
        preload="metadata" 
        onLoadedMetadata={(event) => {
          setDuration(event?.target?.duration)
        }}
        onTimeUpdate={(event) => {
          setCurrentTime(event?.target?.currentTime)
        }}
        onEnded={() => {
          setCurrentTime(0)
          setProgress(0)
          setIsPlaying(false)
        }}
      />
    </Container>
  )
}

export default React.memo(LearnMoreComponent);
